import React, { createContext, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../utils/tokenSetCookie";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
type BrandContextType = {
    logos: {
        websiteLogo: string;
        faviconUrl: string;
        shorturlBackgroundImage: string;
    }
};

const BrandContext = createContext<BrandContextType>({
    logos: {
        websiteLogo: "",
        faviconUrl: "",
        shorturlBackgroundImage: ""
    }
});


export const BrandProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [logos, setLogos] = useState({
        websiteLogo: "",
        faviconUrl: "",
        shorturlBackgroundImage: ""
    })

    useEffect(() => {
        const getLogo = async () => {
            try {
                const url = window.location.hostname;
                console.log("url", url);

                const response = await axiosInstance.post(
                    `${API_BASE_URL}websites/get-website-id`,
                    { url }
                );

                if (response.status >= 200 && response.status <= 300) {
                    setLogos(
                        {
                            websiteLogo: response.data.data.websiteLogo,
                            faviconUrl: response.data.data.faviconUrl,
                            shorturlBackgroundImage: response.data.data.shorturlBackgroundImage
                        })
                }
            } catch (error) {
                console.error("Error fetching website ID:", error);
            }
        }

        getLogo()

    }, [])

    return (
        <BrandContext.Provider value={{ logos }}>
            {children}
        </BrandContext.Provider>
    );
};

export const useBrand = () => {
    const ctx = useContext(BrandContext);
    if (!ctx) throw new Error("useBrand must be used inside BrandProvider");
    return ctx;
};